import { html } from "lit";
import { getDummyText } from "../../../utils";
import { Template as HeadlineTemplate } from "../../../shared/headline";

export function JobOffersTemplate() {
    return html`
        <div class="row ux-u-margin-bottom-40">
            ${HeadlineTemplate()}
            <div class="gr-6 push-3 gr-10@t push-1@t gr-10@m push-1@m">
                <div
                    class="ux-text-normal ux-u-text-align--center ux-u-margin-children-0"
                >
                    <p>${getDummyText()}</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div
                class="gr-12 no-gutter ux-u-background-grey-faded-vertical-upsidedown"
            >
                <div class="row">
                    <div
                        class="gr-10 push-1 push-0@m gr-12@m no-gutter ux-u-margin-vertical-50"
                    >
                        <div
                            class="ux-iws-teaser-image-grid ux-iws-teaser-image-grid--3-xl"
                        >
                            <ux-iws-teaser-image align-cta-top>
                                <div
                                    slot="image"
                                    class="ux-color-white-children"
                                >
                                    <div
                                        class="ux-iws-teaser-image__image-alternative ux-u-background-blue-faded-horizontal ux-u-center-content"
                                    >
                                        <ux-icon
                                            name="graduation-cap-bag"
                                            weight="light"
                                            class="ux-color-white"
                                            size-s="100"
                                        ></ux-icon>
                                    </div>
                                </div>
                                <div slot="text">
                                    <div
                                        class="ux-text-title ux-text-title--light"
                                    >
                                        Description text
                                    </div>
                                </div>
                                <div slot="cta">
                                    <a
                                        class="ux-button ux-button--icon-only"
                                        href="#"
                                        aria-label="Job offer 1"
                                        role="button"
                                    >
                                        <ux-icon
                                            name="chevron-right"
                                            weight="medium"
                                        ></ux-icon>
                                    </a>
                                </div>
                            </ux-iws-teaser-image>
                            <ux-iws-teaser-image align-cta-top>
                                <div
                                    slot="image"
                                    class="ux-color-white-children"
                                >
                                    <div
                                        class="ux-iws-teaser-image__image-alternative ux-u-background-blue-faded-horizontal ux-u-center-content"
                                    >
                                        <ux-icon
                                            name="books"
                                            weight="light"
                                            class="ux-color-white"
                                            size-s="100"
                                        ></ux-icon>
                                    </div>
                                </div>
                                <div slot="text">
                                    <div
                                        class="ux-text-title ux-text-title--light"
                                    >
                                        Description text
                                    </div>
                                </div>
                                <div slot="cta">
                                    <a
                                        class="ux-button ux-button--icon-only"
                                        href="#"
                                        aria-label="Job offer 2"
                                        role="button"
                                    >
                                        <ux-icon
                                            name="chevron-right"
                                            weight="medium"
                                        ></ux-icon>
                                    </a>
                                </div>
                            </ux-iws-teaser-image>
                            <ux-iws-teaser-image align-cta-top>
                                <div
                                    slot="image"
                                    class="ux-color-white-children"
                                >
                                    <div
                                        class="ux-iws-teaser-image__image-alternative ux-u-background-blue-faded-horizontal ux-u-center-content"
                                    >
                                        <ux-icon
                                            name="backpack"
                                            weight="light"
                                            class="ux-color-white"
                                            size-s="100"
                                        ></ux-icon>
                                    </div>
                                </div>
                                <div slot="text">
                                    <div
                                        class="ux-text-title ux-text-title--light"
                                    >
                                        Description text
                                    </div>
                                </div>
                                <div slot="cta">
                                    <a
                                        class="ux-button ux-button--icon-only"
                                        href="#"
                                        aria-label="Job offer 3"
                                        role="button"
                                    >
                                        <ux-icon
                                            name="chevron-right"
                                            weight="medium"
                                        ></ux-icon>
                                    </a>
                                </div>
                            </ux-iws-teaser-image>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
}
